(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galleria-con-overlay"] && !Shopify.designMode) return;
  try {
    
const modal = document.getElementById("imageModal");
const modalImg = document.getElementById("fullImage");
const captionText = document.getElementById("caption");
const galleryImages = [...document.querySelectorAll('.image-item img')];
const closeBtn = document.querySelector(".close");
const prevBtn = document.querySelector(".arrow.left");
const nextBtn = document.querySelector(".arrow.right");

let currentIndex = 0;
const imageCache = new Map();
let isLoading = false;
let isTransitioning = false;

// Precaricare l'immagine
function preloadImage(url) {
  if (imageCache.has(url)) {
    return Promise.resolve(imageCache.get(url));
  }
  
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      imageCache.set(url, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = url;
  });
}

// Precaricare immagini adiacenti in background
function preloadAdjacentImages(index) {
  const nextIndex = (index + 1) % galleryImages.length;
  const prevIndex = (index - 1 + galleryImages.length) % galleryImages.length;
  
  // Precaricare le immagini full-size in background
  if (galleryImages[nextIndex]) {
    preloadImage(galleryImages[nextIndex].dataset.full).catch(() => {});
  }
  if (galleryImages[prevIndex]) {
    preloadImage(galleryImages[prevIndex].dataset.full).catch(() => {});
  }
}

// Precaricare tutte le immagini al caricamento pagina
function preloadAllImages() {
  galleryImages.forEach(img => {
    preloadImage(img.dataset.full).catch(() => {});
  });
}

function showModal(index) {
  // Evita lag da clic multipli
  if (isLoading || isTransitioning) return;
  
  const img = galleryImages[index];
  currentIndex = index;
  const fullUrl = img.dataset.full;
  
  isLoading = true;
  
  // Mostra subito la thumbnail
  modalImg.src = img.src;
  modalImg.style.opacity = "1";
  
  modal.style.visibility = "visible";
  modal.style.opacity = "0";
  
  // Usa setTimeout per evitare lag da requestAnimationFrame
  setTimeout(() => {
    modal.style.opacity = "1";
  }, 10);
  
  // Carica l'immagine full-size in background
  preloadImage(fullUrl).then(fullImg => {
    // Non applicare blur pesante - usa solo opacity
    modalImg.src = fullUrl;
    modalImg.setAttribute("width", fullImg.naturalWidth);
    modalImg.setAttribute("height", fullImg.naturalHeight);
    captionText.textContent = img.alt;
    isLoading = false;
    
    // Precaricare immagini adiacenti
    preloadAdjacentImages(index);
  }).catch(() => {
    isLoading = false;
  });
}

galleryImages.forEach((img, index) => {
  img.addEventListener("click", () => showModal(index));
  // Precaricare le immagini quando l'utente passa sopra
  img.addEventListener("mouseover", () => {
    preloadImage(img.dataset.full).catch(() => {});
  });
});

function closeModal() {
  isTransitioning = true;
  modal.style.opacity = "0";
  
  setTimeout(() => {
    modal.style.visibility = "hidden";
    isTransitioning = false;
  }, 250);
}

function showNext() {
  if (!isLoading && !isTransitioning) {
    currentIndex = (currentIndex + 1) % galleryImages.length;
    showModal(currentIndex);
  }
}

function showPrev() {
  if (!isLoading && !isTransitioning) {
    currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    showModal(currentIndex);
  }
}

closeBtn.addEventListener("click", closeModal);
modal.addEventListener("click", (e) => {
  if (e.target === modal) closeModal();
});
nextBtn.addEventListener("click", showNext);
prevBtn.addEventListener("click", showPrev);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeModal();
  if (e.key === "ArrowRight") showNext();
  if (e.key === "ArrowLeft") showPrev();
});

// Precaricare tutte le immagini quando la pagina è carica
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", preloadAllImages);
} else {
  preloadAllImages();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
